(function () {
  'use strict';

  if (window.__skSaveProcessingModalInstalled) return;
  window.__skSaveProcessingModalInstalled = true;

  var activeSaves = 0;
  var beforeUnloadHandler = function (event) {
    if (activeSaves <= 0) return;
    event.preventDefault();
    event.returnValue = '';
    return '';
  };

  function ensureModal() {
    var existing = document.getElementById('sw-save-processing-modal');
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.id = 'sw-save-processing-modal';
    overlay.setAttribute('role', 'alertdialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'sw-save-processing-title');
    overlay.setAttribute('aria-describedby', 'sw-save-processing-copy');
    overlay.style.cssText = [
      'display:none',
      'position:fixed',
      'inset:0',
      'z-index:10030',
      'background:rgba(0,0,0,.64)',
      'padding:24px',
      'align-items:center',
      'justify-content:center'
    ].join(';');

    overlay.innerHTML = ''
      + '<div style="width:min(520px,100%);background:#fff;border-radius:22px;padding:30px 26px;box-shadow:0 24px 80px rgba(0,0,0,.35);text-align:center;font-family:DM Sans,Arial,sans-serif;">'
      +   '<div aria-hidden="true" style="width:48px;height:48px;margin:0 auto 18px;border:4px solid #ead8cd;border-top-color:#b85c2a;border-radius:50%;animation:swSaveSpin .85s linear infinite;"></div>'
      +   '<style>@keyframes swSaveSpin{to{transform:rotate(360deg)}}</style>'
      +   '<h2 id="sw-save-processing-title" style="margin:0 0 10px;font-family:Playfair Display,Georgia,serif;font-size:28px;line-height:1.15;color:#1c1c1c;">Updating your meals…</h2>'
      +   '<p id="sw-save-processing-copy" style="margin:0 auto 10px;max-width:430px;font-size:16px;line-height:1.55;color:#4a4a4a;">We are updating your weekly selections and subscription.</p>'
      +   '<p style="margin:0 auto;max-width:430px;font-size:15px;line-height:1.55;color:#6b6b6b;"><strong>Please do not exit or refresh this screen, and do not click Update My Meals again.</strong> This may take a moment.</p>'
      + '</div>';

    document.body.appendChild(overlay);
    return overlay;
  }

  function showModal() {
    activeSaves += 1;
    var modal = ensureModal();
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    window.addEventListener('beforeunload', beforeUnloadHandler);
  }

  function hideModal() {
    activeSaves = Math.max(0, activeSaves - 1);
    if (activeSaves > 0) return;
    var modal = document.getElementById('sw-save-processing-modal');
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
    window.removeEventListener('beforeunload', beforeUnloadHandler);
  }

  function installFetchObserver() {
    if (typeof window.fetch !== 'function' || window.fetch.__skSaveProcessingObserver) return;
    var priorFetch = window.fetch.bind(window);
    var wrappedFetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var isWeeklySave = /weekly-selection/.test(url) || /phase2-qa-weekly-selection/.test(url);
      if (!isWeeklySave) return priorFetch(input, init);

      showModal();
      var request;
      try {
        request = priorFetch(input, init);
      } catch (error) {
        hideModal();
        throw error;
      }
      return Promise.resolve(request).then(function (response) {
        hideModal();
        return response;
      }, function (error) {
        hideModal();
        throw error;
      });
    };
    wrappedFetch.__skSaveProcessingObserver = true;
    window.fetch = wrappedFetch;
  }

  function init() {
    ensureModal();
    installFetchObserver();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
